export default __webpack_public_path__ + "static/media/avatar2.7b4d1c6d.jpg";